export default __webpack_public_path__ + "static/media/Soulace_Floor_Plan.4cc1c0aa.pdf";